import script from "./ProfileDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDashboard.vue?vue&type=style&index=0&id=d2113b36&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2113b36"]])

export default __exports__